import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'did_facility_have_other_wage_deductions_besides_legally'

export const dataPointDefinition = {
  retracedId: 'did_facility_have_other_wage_deductions_besides_legally',
  name: 'Did the facility have any other wage deductions (besides legally required withholdings and social security)?',
  description:
    'The intent of this question is to understand if the facility deducts any money from wages outside of legal withholdings and social security. ',
  meta: {
    slcpMeta: {
      key: 'wb-19',
      number: 'WB-WAGE-120',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-19', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35160,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
